import React, { Component } from 'react';
import { Select } from 'vivace-fluent-motion';

class SelectCreatableComponent extends Component {
  constructor () {
    super();
    this.selectRef = React.createRef();
  }
  render() {
    var props = { ...this.props };
    if (this.props.selectRef !== undefined) {
      this.selectRef = this.props.selectRef;
    }

    return (
      <Select
        createTable={true}
        {...props}
        classNamePrefix={`mv-vivace-fluent-motion-select${
          this.props.isMulti ? '-multi' : ''
        }`}
        isClearable
        isCreatable={true}
        height={38}
        innerRef={this.props.innerRef}
        onChange={this.props.onChange}
        onCreateOption={this.handleCreate}
        options={this.props.options}
        tabIndex={this.props.tabIndex}
        placeholder={this.props.placeholder}
        createMessage={ this.props.label}
        value={this.props.value}
        isDisabled={this.props.disabled}
      />
    );
  }

  handleCreate = (value) => {
    this.props.onCreateOption(value);
  };

  focus() {
    this.selectRef && this.selectRef.current.focus();
  }
}

export default SelectCreatableComponent;



// WEBPACK FOOTER //
// ./src/componentes/select/select-creatable.component.js